import React, { useState } from 'react';

const ChooseLayoutParts = ({ partMembers, labelOf, visible, disabled, onNest }) => {
  const [chosenParts, setChosenParts] = useState([]);

  const toggle = (part) => {
    setChosenParts((previous) => (previous.includes(part) ? previous.filter((chosen) => chosen !== part) : previous.concat([part])));
  };

  const nest = () => {
    onNest(chosenParts);
    setChosenParts([]);
  };

  const chosenLabels = partMembers.filter((member) => chosenParts.includes(member.parts[0])).map(labelOf);

  return (
    <div className={`col-lg-12 choose_layout_parts ${visible ? '' : 'hidden'}`}>
      <h4 className="choose_layout_parts__title">{t('layouts.choose_layout_parts_to_nest')}</h4>

      <div className="choose_layout_parts__grid">
        {partMembers.map((member) => {
          const part = member.parts[0];
          const chosen = chosenParts.includes(part);
          const label = labelOf(member);
          const name = member.part_names[0].trim();
          return (
            <button key={member.uuid} type="button" aria-pressed={chosen} disabled={disabled} onClick={() => toggle(part)}
              className={`choose_layout_parts__part ${chosen ? 'is-chosen' : ''}`}>
              <span className="choose_layout_parts__check"><i className="fa fa-check" aria-hidden="true"></i></span>
              <span className="choose_layout_parts__names">
                <span className="choose_layout_parts__label">{label}</span>
                {name !== label && <span className="choose_layout_parts__name">{name}</span>}
              </span>
            </button>
          );
        })}
      </div>

      <div className="choose_layout_parts__footer">
        {chosenLabels.length > 0 && <span className="choose_layout_parts__summary">{chosenLabels.join(', ')}</span>}
        {chosenParts.length > 0 && (
          <button type="button" className="dct-button dct-button--secondary" disabled={disabled} onClick={() => setChosenParts([])}>
            {t('layouts.clear_chosen_layout_parts')}
          </button>
        )}
        <button type="button" className="dct-button dct-button--primary" disabled={disabled || chosenParts.length === 0} onClick={nest}>
          {t('layouts.nest_chosen_layout_parts')}
        </button>
      </div>
    </div>
  );
};

export default ChooseLayoutParts;
